(function()
{
	//Import classes
	var BaseState = include('springroll.easeljs.BaseState'),
		TitlePanel = include('WGBH.TitlePanel');

	/**
	 * The logic for the title state
	 * @class WGBH.TitleState
	 * @extends springroll.easeljs.BaseState
	 */
	var TitleState = function(options)
	{
		BaseState.call(this, new TitlePanel(), options);

		this.onPlay = this.onPlay.bind(this);
	};

	// Extend the base class
	var p = extend(TitleState, BaseState);

	/**
	 * When the transition is done playing and we're fully in
	 */
	p.enterDone = function()
	{
		app.acc_mgr.addInteractiveButton(this.panel.playbt);
		this.panel.playbt.ev_disp.on('BUTTON_DOWN', this.onPlay.bind(this));
		app.voPlayer.play('whichfish');
	};

	/**
	 * Handler when the play button is clicked
	 * @method  onPlay
	 * @private
	 */
	p.onPlay = function()
	{
		app.voPlayer.stop();
		// set up background music
		app.playBackgroundMusic();
		this.nextState();
	};

	/**
	 * When the state fully exits
	 * @method  exit
	 */
	p.exit = function()
	{
		// Release event listeners
		this.panel.playbt.ev_disp.off('BUTTON_DOWN', this.onPlay.bind(this));
		app.acc_mgr.removeButtonsFromDOM();
		this.panel.playbt.clearObject();
	};

	//Assign to namespace
	namespace("WGBH").TitleState = TitleState;
}());
